/** Subcollection under each Firestore `lists/{listId}` document for one row per contact (London Smoke & Cure). */
export const LIST_CONTACTS_SUBCOL = 'contacts';

/** When true on `lists/{id}.metadata`, CRM rows are read and written under `contacts/`, not `recipients[]`. */
export const LIST_METADATA_CONTACTS_SUBCOLLECTION = 'contactsInSubcollection';

export function isListContactsSubcollectionMode(metadata) {
  const m = metadata && typeof metadata === 'object' ? metadata : {};
  return m[LIST_METADATA_CONTACTS_SUBCOLLECTION] === true;
}
